import React from "react";
import * as PIXI from 'pixi.js'
import '../css/Loading.css';
// eslint-disable-next-line
import Worker from '../workers/radar.worker';
import {Paper,Grid} from "@material-ui/core";
import { withStyles } from '@material-ui/styles';
window.PIXI = PIXI;

const styles = {
    root: {
        background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
        border: 0,
        borderRadius: 3,
        boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
        color: 'white',
        height: 48,
        padding: '0 30px',
    },
    textArea:{
        width: '99%',
        maxWidth: 996,
        resize: 'none',
        height: 590,
        float: 'top',
        minHeight: 250,
        overflow: 'scroll',
        margin: 'auto',
        display: 'inline-block',
        background: '#f0c98b',
        outline: 'none',
        fontFamily: 'Courier, sans-serif',
        fontSize: 14
    },
    runButton: {
        marginRight: 5
    },
    canvas: {
        marginTop: 5
    }
};


// Worker
let worker = null;

const RADIUS = 200;

//PixiJS
const app = new PIXI.Application({width:600,height:600,antialias: true});
const CENTER_X = app.view.width/2;
const CENTER_Y = app.view.height/2;
const graphics = new PIXI.Graphics();
app.stage.addChild(graphics);

class Playground extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            num: 1
        }
    }

    render(){
        return(
            <div>
                <div id="loading" style={{margin:"auto",marginTop:'5%'}} className="loading">
                </div>
                <Paper  >
                    <Grid container>
                        <Grid item xs={6} align="center" style={{backgroundColor:'#f57171'}}>
                            <div id="pixi">
                            </div>
                        </Grid>
                    <Grid item xs={6} align="center" style={{backgroundColor:'#f57171'}}>
                        <div  id="canvas">
                        </div>
                    </Grid>
                    </Grid>
                </Paper>
            </div>
        )
    }

    componentDidMount() {
        worker = new Worker();
        runWorker();
    }
    componentWillUnmount() {
        worker.terminate();
    }
}

const createRadarWithPixi = (radarData) => {
    console.time('Creating radar with pixi!');
    function drawRadar(){
        for(let degree = 0 ; degree < radarData.length ; degree++){
            const radarSegmentValues = radarData[degree];
            for(let segment = 0; segment < radarSegmentValues.length ; segment++){
                if(radarSegmentValues[segment] === 0){
                    continue;
                }
                    // graphics.lineStyle(1,0x00FF00,1);
                    graphics.lineStyle(0);
                    graphics.beginFill(0x00FF00, 0.5);
                    graphics.arc( CENTER_X, CENTER_Y, (RADIUS/radarSegmentValues.length)*segment,(Math.PI/180)*degree,(Math.PI/180)*(degree+1));
                    graphics.endHole();
                    graphics.endFill();
                }
            }
    }
    graphics.clear();
    drawRadar();
    document.getElementById('pixi').appendChild(app.view);
    console.timeEnd('Creating radar with pixi!');
};


const createRadarWithCanvas = (radarData) => {
    console.time('Creating radar with canvas!');
    let canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = 600;
    canvas.height = 600;
    ctx.fillStyle = "black";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    const CENTER_X = canvas.width/2;
    const CENTER_Y = canvas.height/2;
    ctx.strokeStyle = '#00FF00';
    function drawRadar(){
        for(let degree = 0 ; degree < radarData.length ; degree++){
            const radarSegmentValues = radarData[degree];
            for(let segment = 0; segment < radarSegmentValues.length ; segment++){
                    if(radarSegmentValues[segment] === 0){
                       continue;
                    }
                    ctx.beginPath();
                    ctx.arc( CENTER_X, CENTER_Y, (RADIUS/radarSegmentValues.length)*segment,(Math.PI/180)*degree,(Math.PI/180)*(degree+1));
                    ctx.stroke();
            }
        }
    }
    drawRadar();
    document.getElementById('canvas').appendChild(canvas);
    console.timeEnd('Creating radar with canvas!');
};

const runWorker = () => {
    worker.postMessage(0);
    worker.addEventListener('message', event => {
        const radarData = event.data;
        const canvasDomElement = document.getElementById('canvas');
        while (canvasDomElement.firstChild) {
            canvasDomElement.firstChild.remove();
        };
        const loadingElement = document.getElementById("loading");
        loadingElement && loadingElement.parentNode.removeChild(loadingElement);
        createRadarWithPixi(radarData);
        createRadarWithCanvas(radarData);
});
};


export default withStyles(styles)(Playground);